import { Button } from "@altimateai/lego";
import { useState } from "react";
import CoachForm from "../../../teammate/CoachForm";
import { useChatContext } from "../../ChatProvider";
import { ThinkingIcon } from "../../../../assets/icons";

export const CoachAI = () => {
  const { taskLabel } = useChatContext();
  const [showCoachForm, setShowCoachForm] = useState(false);

  if (!taskLabel) return null;
  return (
    <>
      {showCoachForm ? (
        <CoachForm
          taskLabel={taskLabel}
          onClose={() => setShowCoachForm(false)}
        />
      ) : (
        <Button
          size="sm"
          onClick={() => setShowCoachForm(true)}
          variant="outline"
        >
          <ThinkingIcon />
          Coach Agent
        </Button>
      )}
    </>
  );
};
